import { colors } from '@flowwai-frontend/shared/style-guide'

export const pipelineTaskTemplatesTheme = {
   // #region - light theme config
   light: {
      common: {
         closeIconBGColor: colors['gray-500'],
         borderColor: 'border-gray-300'
      },
      taskTemplates: {
         plusIconColor: colors['base-white'],
         headerBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         templateNameTextColor: 'text-gray-700',
         templateDescriptionTextColor: 'text-gray-700',
         taskTemplatesContainerBgColor: 'bg-gray-100',
         createdAtTextColor: 'text-gray-600',
         createTaskTemplate: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600'
         },
         imageContainerBgColor: 'bg-gray-100',
         linkedFieldsToggle: {
            description: 'text-gray-600',
            titleTextColor: 'text-gray-700'
         },
         body: {
            bodyBGColor: 'bg-gray-100'
         },
         header: {
            headerBGColor: 'bg-white',
            borderColor: 'border-gray-200',
            headerTextColor: 'text-gray-900',
            chevronLeftIconColor: colors['primary-700']
         }
      },
      configurations: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-700',
         fieldTextColor: 'text-gray-600',
         stageQuickEditFieldsToggle: {
            description: 'text-gray-600',
            titleTextColor: 'text-gray-700'
         },
         dotsIconColor: colors['gray-500'],
         addOptionButtonBGColor: '!bg-transparent',
         plusIconFillColor: colors['primary-600']
      },
      templateDetails: {
         titleTextColor: 'text-gray-500',
         horizontalLineColor: 'border-gray-300',
         sectionDividerColor: 'border-gray-200',
         valueTextColor: 'text-gray-800',
         labelTextColor: 'text-gray-700',
         hintTextColor: 'text-gray-600',
         titleColor: 'text-gray-900',
         disabledLabelColor: 'text-gray-400',
         selectedTextColor: 'text-primary-600',
         selectedBorderColor: 'border-primary-600',
         unSelectedBorderColor: 'border-gray-300'
      }
   },
   // #endregion

   dark: {}
   // #endregion
}
